import { isValidPhoneNumber } from "react-phone-number-input";

export type AddressData = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
};

export type FormData = {
  dealerName: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  address: AddressData;
  preferredContact?: string;
};

export type ProviderInfo = {
  dealerName: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  consigneeId: string;
  dealerAcknowlegement: boolean;
  informUserMyself: boolean;
  providePermobilData: boolean;
  preferredContactType: string;
  selectedCountry: string;
  noConsigneeId?: boolean;
};
export type userDataInfo = {
  consigneeId: string;
  noConsigneeId?: boolean;
  consigneeIdValid: boolean;
  userAcknowledgement: boolean;
  numInPosession: number;
  numUnitsReturn: number;
  numSwitchReplace: number;
  numButtonReplace: number;
  noReplacement: boolean;
  contactMetoDiscuss: boolean;
  serialNumber?: string;
  noReplacementReason: string;
  dealerName: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  selectedCountry: string;
  preferredContactType: string;
};

export const validate = (
  form: FormData,
  setErrors: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string;
    }>
  >
): boolean => {
  const newErrors: { [key: string]: string } = {};
  // Use Unicode property escapes (\p{L} = any kind of letter, \p{M} = combining marks)
  // Hyphen, apostrophe, and space are allowed
  //below are unicode validations
  // const nameRegex = /^[\p{L}\p{M}'’\- ]+$/u;

  // if (!form.firstName.trim() || !nameRegex.test(form.firstName)) {
  //   newErrors.firstName =
  //     "Name should contain only letters and basic name characters.";
  // }

  // if (!form.lastName.trim() || !nameRegex.test(form.lastName)) {
  //   newErrors.lastName =
  //     "Name should contain only letters and basic name characters.";
  // }

  // Updated email regex (still simple, but less restrictive, supports unicode domains)
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;

  // if (!form.email.trim() || !emailRegex.test(form.email)) {
  //   newErrors.email = "Invalid email address.";
  // }

  if (!form.firstName.trim() || !/^[a-zA-Z\s]*$/.test(form.firstName))
    newErrors.firstName = "Name should contain only letters and spaces.";
  if (!form.lastName.trim() || !/^[a-zA-Z\s]*$/.test(form.lastName))
    newErrors.lastName = "Name should contain only letters and spaces.";
  if (!form.phone.trim() || !isValidPhoneNumber(form.phone)) {
    newErrors.phone = "Please enter a valid phone number.";
  }

  if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    newErrors.email = "Invalid email address.";
  }

  const { country } = form.address;

  if (!country.trim()) {
    newErrors.country = "Country is required.";
  }

  const requiredFieldsByCountry: Record<string, (keyof typeof form.address)[]> =
    {
      JP: ["zipcode", "state", "city", "line1"],
      KR: ["zipcode", "state", "city", "line1"],
      HK: ["city", "line1"],
      SG: ["zipcode", "city", "line1"],
      TW: ["zipcode", "city", "line1"],
    };

  const defaultRequiredFields: (keyof typeof form.address)[] = [
    "zipcode",
    "state",
    "city",
    "line1",
  ];

  const countryCode = sessionStorage.getItem("country") || "";
  const requiredFields =
    requiredFieldsByCountry[countryCode] || defaultRequiredFields;

  const labelMap: Record<string, string> = {
    line1: "Address Line 1",
    city: "City",
    state: "State / Province",
    country: "Country",
    zipcode: "Postal Code",
  };

  requiredFields.forEach((field) => {
    if (!form.address[field]?.trim()) {
      newErrors[field] = `${labelMap[field]} is required.`;
    }
  });

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

export const isFormEmpty = (form: FormData): boolean => {
  const { firstName, lastName, phone, email, address } = form;
  const { country } = address;

  if (
    !firstName?.trim() ||
    !lastName?.trim() ||
    !phone?.trim() ||
    !email?.trim()
  ) {
    return true;
  }

  if (!country?.trim()) return true;

  const countryCode = sessionStorage.getItem("country") || "";
  const requiredFieldsByCountry: Record<string, (keyof typeof address)[]> = {
    JP: ["zipcode", "state", "city", "line1"],
    KR: ["zipcode", "state", "city", "line1"],
    HK: ["city", "line1"],
    SG: ["zipcode", "city", "line1"],
    TW: ["zipcode", "city", "line1"],
  };

  const defaultRequiredFields: (keyof typeof address)[] = [
    "line1",
    "city",
    "state",
    "zipcode",
  ];
  const requiredFields =
    requiredFieldsByCountry[countryCode] || defaultRequiredFields;

  for (const field of requiredFields) {
    if (!address[field]?.trim()) return true;
  }

  return false;
};

export function deepEqual(a: any, b: any): boolean {
  if (a === b) return true;

  if (typeof a !== "object" || typeof b !== "object" || a == null || b == null)
    return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (let key of keysA) {
    if (!keysB.includes(key)) return false;
    if (!deepEqual(a[key], b[key])) return false;
  }

  return true;
}
